var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 9C27.5523 9 28 9.44772 28 10V12C28 12.5523 27.5523 13 27 13V9Z",
    fill: "#F17664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3478 6H23.6522C24.9488 6 26 7.11929 26 8.5V13.5C26 14.8807 24.9488 16 23.6522 16H10.3478C9.05116 16 8 14.8807 8 13.5V8.5C8 7.11929 9.05116 6 10.3478 6ZM10.3478 6.83333C9.48338 6.83333 8.78261 7.57953 8.78261 8.5V13.5C8.78261 14.4205 9.48338 15.1667 10.3478 15.1667H23.6522C24.5166 15.1667 25.2174 14.4205 25.2174 13.5V8.5C25.2174 7.57953 24.5166 6.83333 23.6522 6.83333H10.3478Z",
    fill: "#F17664"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_58_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10 8.44772 10.4477 8 11 8H14V14H11C10.4477 14 10 13.5523 10 13V9Z",
    fill: "url(#paint0_linear_58_17)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_58_17",
    x: -6.6555,
    y: -8.6555,
    width: 37.311,
    height: 39.311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.32775
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_58_17"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.416388,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_58_17"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.66555
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.99665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_58_17",
    result: "effect2_dropShadow_58_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_58_17",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_17",
    x1: 10.6344,
    y1: 8,
    x2: 15.0972,
    y2: 9.70274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17664",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17664"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.20344fbc6509f23054466152b8b0a9d6.svg";
export { ForwardRef as ReactComponent };